import React from 'react';
import {connect} from 'react-redux';
import Descriptions from './progressive-descriptions';
import ParameterDescriptions from './parameter-description';


/**
 * Request description in live console tab 
 */

class DescriptionInLiveConsole extends React.Component
{

   render()
   {
        const hasQueryParams = this.props.hasQueryParams || false;
        const hasBodyParams = this.props.hasBodyParams || false;
        const pathParams = this.props.pathParams || [];
        const jsTree = this.props.jsTree || [];
        const headerParams = this.props.headerParameters || [];
        const liveConsoleTabIndex = this.props.liveConsoleTabIndex || 0;
        const isHeadersTabHidden = this.props.isHeadersTabHidden || false;

        // Calculate the expected index for the Descriptions tab
        let descriptionsTabIndex = 3; // Default position
        
        // Adjust index based on disabled/hidden tabs
        if (!hasBodyParams) {
            descriptionsTabIndex--; // Body tab is removed
        }
        if (isHeadersTabHidden) {
            descriptionsTabIndex--; // Headers tab is removed
        }
        if (!hasQueryParams) {
            descriptionsTabIndex--; // Query Parameters tab is removed
        }

        // Only render if the descriptions tab is currently active
        if (liveConsoleTabIndex !== descriptionsTabIndex) {
            return <div id="descriptionsTab"></div>;
        }

       return(
            <div id = "descriptionsTab">
                    {
                    hasBodyParams &&
                    <div id = "requestDescriptionsTab">
                            <Descriptions
                                jsTree={jsTree}
                                display = "block"
                                parent = "root"
                                type = "request"
                            />
                    </div>
                    }
                    {hasQueryParams &&
                    <ParameterDescriptions type = "Query" src="request"/>  
                    }
                    {pathParams.length > 0 &&
                    <ParameterDescriptions type="Path" src="request"/>  
                    }
                     {headerParams.length > 0 &&
                        <ParameterDescriptions type="Header" src="request"/>  
                    }
            </div>
       );

    }
}
function mapStateToProps(state){
    return{      
        hasQueryParams: state.rhsReducer.hasQueryParams,
        hasBodyParams : state.lhsReducer.hasBodyParams,
        pathParams: state.rhsReducer.pathParameters,
        jsTree: state.rhsReducer.jsTree,
        headerParams : state.rhsReducer.headerParameters,
        liveConsoleTabIndex: state.rhsReducer.liveConsoleTabIndex, // Add this
        isHeadersTabHidden: state.lhsReducer.noAuth // Add this
    };
   
}

export default connect(mapStateToProps)(DescriptionInLiveConsole);
